import Api from '@/api/api'

export default {
    getSensors(facilityID) {
        console.log('getSensors Facility is : ', facilityID);
        return Api.get(`/api/Sensor/GetSensors`);
    },
    getSensorById(sensorId) {
        console.log('[ getSensorById API is under Consturction ] Params Passed => ', sensorId);
        return Api.get(`/api/Sensor/GetSensorByID/${sensorId}`)
        
    },
    updateSensor(editId, body) {
        console.log('[ updateSensor API is under Consturction ] Params Passed => ', editId, body);
        return Api.put(`/api/Sensor/UpdateSensor/${editId}`, body);
    },
    deleteSensor(id) {
        console.log('[ deleteSensor API is under Consturction ] Params Passed => ', id);
        return Api.delete(`/api/Sensor/DeleteSensor/${id}`);
    },
    async addSensor(body) {
        console.log('[ deleteSensor API is under Consturction ] Params Passed => ', body);
        return Api.post(`/api/Sensor/AddSensor`, body);
    }
}

